/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FeatureFlagResponse
 */
export interface FeatureFlagResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FeatureFlagResponse
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the FeatureFlagResponse interface.
 */
export function instanceOfFeatureFlagResponse(value: object): value is FeatureFlagResponse {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function FeatureFlagResponseFromJSON(json: any): FeatureFlagResponse {
    return FeatureFlagResponseFromJSONTyped(json, false);
}

export function FeatureFlagResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeatureFlagResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
    };
}

export function FeatureFlagResponseToJSON(json: any): FeatureFlagResponse {
    return FeatureFlagResponseToJSONTyped(json, false);
}

export function FeatureFlagResponseToJSONTyped(value?: FeatureFlagResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
    };
}

